export default function cellKeyboardNavigation(plugin: any) {
	const grid = plugin;

	let wasEditing = false;

	const cs = grid.lookupFeature('CellSelection');
	cs.handleRIGHT = (grid: any, e: any) => {
		// Store for whether or not to edit on next cell
		wasEditing = e.editor !== void 0;
		grid.moveSingleSelect(1, 0);
	};
	cs.handleLEFT = (grid: any, e: any) => {
		// Store for whether or not to edit on next cell
		wasEditing = e.editor !== void 0;
		grid.moveSingleSelect(-1, 0);
	};

	grid.moveSingleSelect = (offsetX: number, offsetY: number) => {
		// We are in the context of the grid
		const columnCount = grid.getColumnCount();
		const mouseCorner = grid.getMouseDown().plus(grid.getDragExtent());
		const rowCount = grid.getRowCount();

		let newX = mouseCorner.x + offsetX;
		let newY = mouseCorner.y + offsetY;

		// Go to next row
		if (newX >= columnCount) {
			newX = 0;
			newY++;
		}
		// Go to previous row
		else if (newX < 0) {
			newX = columnCount - 1;
			newY--;
		}

		// Go to last row
		if (newY < 0) {
			newY = rowCount - 1;
		}
		// Go to first row
		else if (newY >= rowCount) {
			newY = 0;
		}

		grid.moveToSingleSelect(newX, newY);

		// @ts-ignore
		if (!this.readOnly && wasEditing) {
			// The frustrations. Notice we have to add 1 to y here but not for selection...
			grid.editAt(new grid.behavior.CellEvent(newX, newY + 1));
		}
		wasEditing = false;
	};
}
